import React from "react";
import { TransportItem, ScoredFlight } from "../../types";
import { formatDate, formatTime, formatPrice } from "../../functions/Utils";
import { Card } from "react-bootstrap";
import "../../styles/FlightCard.css";

const getIataCode = (airport_name: string) => {
  const match = airport_name.match(/\b[A-Z]{3}\b$/);
  return match ? match[0] : null;
};

const FlightCard = ({ flight }: { flight: TransportItem }) => {
  return (
    <Card className="border-gray-300 p-0 mb-1">
      <div className="flight-card d-flex flex-row align-items-center p-3 my-2">
        {flight?.cpd?.img ? (
          <img
            style={{ maxWidth: "100px", maxHeight: "40px" }}
            src={flight?.cpd?.img}
            alt="airline logo"
            className="airline-logo me-3"
          />
        ) : (
          <span style={{ width: "64px", maxHeight: "40px" }} className="me-3">
            {flight?.cpd?.n}
          </span>
        )}

        <div className="text-center me-4">
          <div className="fw-bold">{formatTime(flight.dep)}</div>
          <div className="text-muted small">{getIataCode(flight.nf)}</div>
        </div>

        <div className="flex-grow-1 text-center px-2">
          <div className="flight-line d-flex align-items-center justify-content-center">
            <div className="line" />
            {Array(flight.ch)
              .fill(0)
              .map((change) => (
                <>
                  <div className="stop-icon"></div>
                  <div className="line" />
                </>
              ))}
          </div>
          <div className="text-muted small me-2">
            {Math.floor(flight.du / 60)}h {flight.du % 60}m
          </div>
        </div>

        <div className="text-center mx-4">
          <div className="fw-bold">{formatTime(flight.arr)}</div>
          <div className="text-muted small">{getIataCode(flight.nt)}</div>
        </div>

        <div className="text-end ms-auto">
          <div className="fw-bold fs-5 text-secondary">
            {formatPrice(flight.A, flight.C)}
          </div>
        </div>
      </div>
    </Card>
  );
};

export default FlightCard;
